(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PrintCompanyCustomerFormDataController', PrintCompanyCustomerFormDataController);

    PrintCompanyCustomerFormDataController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', '$window', 'CompanyCustom', '__config', 'CompanyCustomerFormDataReportCustom'];

    function PrintCompanyCustomerFormDataController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, $window, CompanyCustom, __config, CompanyCustomerFormDataReportCustom) {

        var vm = this;

        vm.customerFormData = entity;
        vm.__config = __config;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.openPrintPreview = openPrintPreview;


        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {
            initTableRows();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.reportExport.company_customer_form_data_report') {
                    $state.go('supplierPanel-v2.reportExport.company_customer_form_data_report');
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.reportExport.company_customer_form_data_report');

        }

        function okModal() {
            openPrintPreview();
        }


        function openPrintPreview() {
            $window.print();
        }

        function initTableRows() {
            vm.tableRows = [];
            var row = [];
            var j = 0;

            for (var i = 0; i < vm.customerFormData.intakeDataDTO.fields.length; i++) {
                if (vm.customerFormData.intakeDataDTO.fields[i].field.fieldType == 'TextArea') {
                    if (row.length > 0) {
                        vm.tableRows.push(row);
                        row = [];
                        j = 0;
                    }
                    var row_area = [];
                    row_area.push(vm.customerFormData.intakeDataDTO.fields[i]);
                    vm.tableRows.push(row_area);
                } else {
                    if (j % 4 == 0) {
                        if (row.length > 0)
                            vm.tableRows.push(row);
                        row = [];
                        j = 0;
                    }
                    row.push(vm.customerFormData.intakeDataDTO.fields[i])
                }
                j++;
            }

            if (row.length > 0)
                vm.tableRows.push(row);

        }

    }
})();
